import styled from 'styled-components';
import { IProduct } from '../../../../../interfaces/Product.interfaces';

interface ProductContentImageSectionProps {
  product: IProduct;
}

export const ProductContentImageSection = ({ product }: ProductContentImageSectionProps) => {
  return (
    <ImageWrapper>
      {/* alt에 id를 쓰면 이미지 로드 실패 시 매물 id가 본문에 그대로 노출된다 */}
      <img key={product.id} src={product.contentImageUrl} alt={'매물 상세 이미지'} />
    </ImageWrapper>
  );
};

const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
